import ContentFrame from 'components/Frame/ContentFrame'
import PeriodizationVisualizer from 'components/ProgramGenerator/Periodization/PeriodizationVisualizer'

export default function PeriodizationSteps({
    labelPrefix = '',
    bAndCRaces = [],
    volumeProgressionModifier = 0,
    periodizationSteps = null
}) {

    const GetProgramPhaseColorClass = (programPhaseKey) => {
        if (programPhaseKey === 're-introduction') return 'bg-orange-100'
        if (programPhaseKey === 'reload') return 'bg-orange-100'
        if (programPhaseKey === 'off-season') return 'bg-orange-200'
        if (programPhaseKey === 'early-season') return 'bg-orange-300'
        if (programPhaseKey === 'in-season') return 'bg-orange-400'
        if (programPhaseKey === 'competition') return 'bg-orange-500'
        if (programPhaseKey === 'championship') return 'bg-orange-600'
        if (programPhaseKey === 'post-race-deload') return 'bg-orange-100'
        return 'bg-gray-200'
    }

    const RenderProgramPhasesConfigChart = (config) => {
        if (!config) return null

        const entries = Object.entries(config).filter(
            ([phase, value]) => phase !== 'post-race-deload' && value > 0
        )

        if (entries.length === 0) return null

        const total = entries.reduce((sum, [, value]) => sum + value, 0)

        return (
            <div className="space-y-2">
                <div className="flex h-8 w-full overflow-hidden rounded-md border border-gray-300 bg-gray-100">
                    {entries.map(([phase, value]) => {
                        const percentage = total > 0 ? (value / total) * 100 : 0
                        return (
                            <div
                                key={phase}
                                className={`flex items-center justify-center text-[10px] sm:text-xs text-gray-900 ${GetProgramPhaseColorClass(
                                    phase
                                )}`}
                                style={{ width: `${percentage}%` }}
                            >
                                <span className="px-1 whitespace-nowrap text-xs">
                                    {/* {phase}  */}
                                    {value}
                                </span>
                            </div>
                        )
                    })}
                </div>

                <div className="flex flex-wrap gap-2 text-xs text-gray-700">
                    {entries.map(([phase, value]) => (
                        <div key={phase} className="flex items-center gap-1">
                            <span
                                className={`inline-block h-3 w-3 rounded text-xs ${GetProgramPhaseColorClass(
                                    phase
                                )}`}
                            />
                            <span className="text-xs">
                                {phase} 
                                {/* ({value}) */}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    if (periodizationSteps === null) {
        return null
    }

    return (
        <>
            <ContentFrame>
                <div className='p-4 space-y-4'> 
                    <div className='text-center'>{labelPrefix} Program Phases Config</div>

                    <div className="text-left">
                        {RenderProgramPhasesConfigChart(periodizationSteps.programPhasesConfigJSON)}
                    </div>
                </div>
            </ContentFrame>

            <PeriodizationVisualizer
                label={labelPrefix + " Raw Periodization"}
                periodizationArray={periodizationSteps.rawPeriodization}
            />

            {volumeProgressionModifier > 0 && 
                <PeriodizationVisualizer
                    label={labelPrefix + " Volume Progression Modifier Periodization"}
                    periodizationArray={periodizationSteps.volumeProgressionModifierPeriodization}
                />
            }

            <PeriodizationVisualizer
                label={labelPrefix + " End of Phase Deload Periodization"}
                periodizationArray={periodizationSteps.endOfPhaseDeloadPeriodization}
            />

            {bAndCRaces.length > 0 && (
                <PeriodizationVisualizer
                    label={labelPrefix + " Supplemental Event Deload Periodization"}
                    periodizationArray={periodizationSteps.supplementalEventDeloadPeriodization}
                />
            )}
        </>
    )
}